import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Constants } from "../../Common/Constants";
import { types } from "../../../Redux/Actions/types";
import TextField from "../../Common/Fields/TextField";
import ButtonCustom from "../../Common/Fields/ButtonCustom";
import {
  bodyGroupInsert,
  bodyGroupList,
  bodyGroupUpdate,
} from "../../../Redux/Actions";
import usePermissions from "../../Common/Functions/usePermissions";

const BodyGroupForm = () => {
  const dispatch = useDispatch();
  const { bodyGroupSingle } = useSelector((state) => state.BodyGroup);
  // Initial values to body group form
  const [initialValues, setInitialValues] = useState({
    name: "",
  });
  // Permissions
  const addPermission = usePermissions(Constants.permission.BODY_PART_ADD);
  const editPermission = usePermissions(Constants.permission.BODY_PART_EDIT);

  // Validations for body group form
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(Constants.required),
  });

  useEffect(() => {
    // Set initial values to pre fill body group form
    if (bodyGroupSingle?._id) {
      const editValue = {};
      for (const [key] of Object.entries(initialValues)) {
        if (bodyGroupSingle[key]) {
          editValue[key] = bodyGroupSingle[key];
        }
        setInitialValues(editValue);
      }
    }
  }, [bodyGroupSingle]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Add or update bodyGroupSingle API
        let submitFunc = bodyGroupInsert(values);
        if (bodyGroupSingle._id) {
          values.id = bodyGroupSingle._id;
          submitFunc = bodyGroupUpdate(values);
        }
        dispatch(submitFunc).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            dispatch({
              type: types.SUCCESS_ALERT_VISIBLE,
              payload: response.message,
            });
            dispatch({ type: types.BODY_GROUP_SINGLE, payload: "" });
            dispatch({ type: types.BODY_GROUP_FORM_MODEL, payload: "" });
          }
          dispatch(bodyGroupList());
        });
      }}
    >
      {({ errors, touched }) => (
        <Form className="row">
          <div className="col-md-12 mb-2">
            <TextField
              type="text"
              name="name"
              className="form-control"
              errors={touched?.name ? errors?.name : undefined}
              touched={touched?.name}
              label={Constants.name}
            />
          </div>
          {((addPermission && !bodyGroupSingle?._id) ||
            (editPermission && bodyGroupSingle?._id)) && (
            <ButtonCustom label={Constants.submit} type="submit" />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default BodyGroupForm;
